export var AppMode;
(function (AppMode) {
    AppMode["production"] = "production";
    AppMode["development"] = "development";
})(AppMode || (AppMode = {}));
